// @flow
import { SET_NOTIFICATION_RESOLVED_PARAMS, RESOLVE_NOTIFICATION_PARAMS } from './actionTypes';
import type { ResolvedParams } from './resolvedParams';

export function setNotificationResolvedParams(resolvedParams: ResolvedParams): TrovitAction {
  return {
    type: SET_NOTIFICATION_RESOLVED_PARAMS,
    payload: {
      resolvedParams,
    },
  };
}

export function resolveNotificationParams(alertControlToken: String): TrovitAction {
  return {
    type: RESOLVE_NOTIFICATION_PARAMS,
    payload: {
      alertControlToken,
    },
  };
}



// WEBPACK FOOTER //
// ./app/NotificationsManager/email/resolvedParams/actions.js